import React, { useMemo } from "react";

// Componente reutilizável de fundo galaxy para todas as páginas (exceto RLCP)
const GalaxyBackground: React.FC = () => {
  const stars = useMemo(
    () =>
      Array.from({ length: 120 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 2.5 + 0.5,
        delay: Math.random() * 4,
        duration: Math.random() * 3 + 2,
      })),
    []
  );

  return (
    <>
      <div className="wonder-stars">
        {stars.map((s) => (
          <div
            key={s.id}
            className="wonder-star"
            style={{
              left: `${s.x}%`,
              top: `${s.y}%`,
              width: `${s.size}px`,
              height: `${s.size}px`,
              animationDelay: `${s.delay}s`,
              animationDuration: `${s.duration}s`,
            }}
          />
        ))}
      </div>
      <div className="grain-overlay" />
      <div className="wonder-nebula-layer" />
      <div className="wonder-galaxy-spotlight" />
    </>
  );
};

export default GalaxyBackground;
